module.exports = __webpack_public_path__ + "img/Patch22-1.3de6eae8.webp";